import { useState, useEffect } from "react";

// Ορισμός θεμάτων για τη σελίδα ρυθμίσεων εμφάνισης
const themes = [
  { id: "teal", name: "Teal (Default)", primary: "#0d9488" },
  { id: "indigo", name: "Indigo Night", primary: "#4f46e5" },
  { id: "rose", name: "Ruby Rose", primary: "#e11d48" },
  { id: "emerald", name: "Emerald Forest", primary: "#059669" },
  { id: "amber", name: "Sunset Amber", primary: "#d97706" },
  { id: "violet", name: "Royal Violet", primary: "#7c3aed" },
  { id: "slate", name: "Slate Corporate", primary: "#475569" },
] as const;

// Δημιουργία τύπου βασισμένου στα id των θεμάτων
type ThemeId = (typeof themes)[number]["id"];

export const ThemeList = () => {
  const [currentTheme, setCurrentTheme] = useState<ThemeId>("teal");

  useEffect(() => {
    // 1. Διαβάζουμε από το localStorage
    const savedTheme = (localStorage.getItem("app-theme") as ThemeId) || "teal";
    setCurrentTheme(savedTheme);

    // 2. Εφαρμόζουμε το data-theme στο HTML αμέσως μόλις φορτώσει το component
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const handleThemeChange = (themeId: ThemeId) => {
    setCurrentTheme(themeId);
    document.documentElement.setAttribute("data-theme", themeId);
    localStorage.setItem("app-theme", themeId);
  };

  return (
    <div>
      <p className="text-gray-600 mb-6">
        Επιλέξτε την αγαπημένη σας χρωματική παλέτα για την εφαρμογή:
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {themes.map((t) => (
          <button
            key={t.id}
            onClick={() => handleThemeChange(t.id)}
            className={`flex items-center justify-between p-4 rounded-xl border-2 transition-all text-left ${
              currentTheme === t.id
                ? "border-primary bg-secondary shadow-md"
                : "border-gray-200 hover:border-gray-300"
            }`}
          >
            <span className="font-medium text-dark">{t.name}</span>
            <div
              className="w-8 h-8 rounded-full shadow-inner shrink-0"
              style={{ backgroundColor: t.primary }}
            />
          </button>
        ))}
      </div>
    </div>
  );
};
